import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import CajasDeslizantes from "../../components/ui/CajasDeslizantes";
import CarouselServicio from "./components/CarouselServicio";
import "./Services.css";

export default function Servicios() {
  const { t } = useTranslation();
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.5 })

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.4,
      },
    );

    const descripciones = document.querySelectorAll(".descripcion-mini");
    descripciones.forEach((desc) => observer.observe(desc));

    return () => {
      descripciones.forEach((desc) => observer.unobserve(desc));
    };
  }, []);

  return (
    <>
      <section className="servicios-section">
        <CarouselServicio />

        <motion.div
           ref={ref}
           className="caja-inicial"
           initial={{ opacity: 0, y: 50 }}
           whileInView={{ opacity: 1, y: 0 }}
           transition={{ duration: 1 }}
           viewport={{ once: true }}
         >
           <motion.p
             className="texto-estatico-servicios"
             initial={{ opacity: 0 }}
             animate={inView ? { opacity: 1 } : {}}
             transition={{ duration: 0.8 }}
           >
             {t("servicios.intro")}
           </motion.p>
         </motion.div>
 
         <CajasDeslizantes />
       </section>
     </>
   );
 }
